import { Link } from "react-router-dom";
import featuretwogirl from "../../assets/images/media/feature-two-girl.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

const WhyChooseUs = ({ handleButtonClick }) => {
 const benefits = [
  "Llega a más clientes.",
  "Maneja tu tienda de forma sencilla.",
  "Automatiza tus ventas.",
  "Base de datos de tus clientes.",
  "La comisión mas baja del mercado.",
  "Controla tu inventario. (Hasta 180 productos)",
  "Certificado de Seguridad SSL.",
  "Pago seguro con cybersource y 3d Secure.",
  "Depositos en 24Hrs.",
 ];
 return (
  <>
   <div className="vcamp-text-block-eleven mt-70 lg-mt-70" id="section-two">
    <div className="container">
     <div className="row align-items-center">
      <div className="col-lg-6" data-aos="fade-right">
       <div className="title-style-nine">
        <div className="upper-title">¿Porqué elegirnos?</div>
        <h2 className="title">
         La solución para
         <br />
         tu Negocio<span>Power</span>.
        </h2>
       </div>
      </div>
      <div
       className="col-lg-5 ms-auto"
       data-aos="fade-left"
       style={{ paddingTop: "30px" }}
      >
       <p className="meta-info-text md-pt-30">
        <span>Nos adaptamos a tu negocio</span> con
        <br /> diseños 100% adaptables a todos los dispositivos.
       </p>
      </div>
     </div>
    </div>
   </div>
   <div
    className="vcamp-text-block-one mt-70 xl-mt-60 md-mt-30"
    data-aos="fade-right"
   >
    <div className="container">
     <div className="row">
      <div className="col-xxl-5 col-xl-6 col-lg-7 ms-auto">
       <div className="text-wrapper pt-0">
        <div className="title-style-two">
         <h3 className="title"> </h3>
        </div>
        <ul style={{}}>
         {benefits.map((elem, i) => {
          return (
           <li
            key={i + "lista"}
            style={{
             marginTop: "0",
             marginBottom: "1rem",
             fontFamily: "avenirroman",
             fontSize: "20px",
            }}
           >
            {elem}
           </li>
          );
         })}
        </ul>
        <Link
         to="/nueva-tienda"
         className="theme-btn-onev2"
         onClick={() =>
          handleButtonClick(
           "Beneficios",
           "clic en boton",
           "Cualidades Comenzar"
          )
         }
        >
         Comenzar
        </Link>
       </div>
      </div>
     </div>
    </div>

    <div className="left-img-meta">
     <LazyLoadImage src={featuretwogirl} alt="powerbizz2" />
    </div>
   </div>
  </>
 );
};

export default WhyChooseUs;
